// Turbo removed - using traditional page loads for CallRail compatibility
import "./controllers";

import * as bootstrap from "bootstrap";
if (!bootstrap) {
  throw new Error("Couldn't load bootstrap");
}
import "./ls";
